import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

function FullScreenSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-fh-gray-light">
      <div className="h-10 w-10 border-4 border-fh-red border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <FullScreenSpinner />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (requireAdmin && user.role !== "admin") {
    return (
      <div className="p-8 max-w-lg mx-auto">
        <div className="card p-6">
          <h2 className="text-xl mb-2">Zugriff verweigert</h2>
          <p className="text-fh-gray">Diese Seite ist nur für Admins.</p>
        </div>
      </div>
    );
  }
  return children;
}
